module.exports = "/static/assets/a34e9e4e9fe1e7cce45eebd2c471fb0c.png";